import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useFulfillmentNavigation } from "../../workspaces/supply/navigation";
export const Route = createFileRoute("/_console/p/$org/$project/orders")({ component: OrdersLayout });
function OrdersLayout() {
  useFulfillmentNavigation("experience-orders");
  return <Outlet />;
}
